import React, { useCallback, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';

import { useTranslation } from '../../../localization/useTranslation';
import Tl from '../../../localization/LocalizationKeys';
import '@patternfly/react-core/dist/styles/base.css';
import {
  Form
} from '@patternfly/react-core';
import ModelsContainer from '../../Model/ModelsContainer';
import ModelType from '../../Model/ModelType';
import { NodeType } from '../../../utils/types';
import { saveButtons } from '../../Modals/ModalButtons';

const AssetDetail = ({ item, setItem }) => {
  const [saveEnabled, setSaveEnabled] = useState(false);
  const [updatedItem, setUpdatedItem] = useState();
  const T = useTranslation();

  const _onSave = useCallback(() => {
    setItem({ ...updatedItem });
    setSaveEnabled(false);
  }, [setItem, updatedItem]);

  const _setItem = useCallback((newItem) => {
    setSaveEnabled(true);
    setUpdatedItem(newItem);
  }, []);

  useEffect(() => {
    setUpdatedItem({ ...item });
    setSaveEnabled(false);
  }, [item]);

  const model = useMemo(() => {
    return [
      {
        type: ModelType.TEXT,
        label: Tl.common.parent,
        path: 'parent.displayName',
        placeholder: Tl.admin.assetInfo.parent.placeholder,
        isReadOnly: true
      },
      {
        type: ModelType.TEXT,
        label: Tl.common.name,
        path: 'displayName',
        placeholder: Tl.admin.assetInfo.name.placeholder,
        isRequired: true,
        hasError: _.isEmpty,
        isReadOnly: (item?.type !== NodeType.Node) ? true : false
      }
    ];
  }, [item?.type]);


  return (
    <Form id="form">
      <ModelsContainer models={model} data={updatedItem} setData={_setItem} />
      { saveButtons({
        T,
        onSave: _onSave,
        saveEnabled: saveEnabled,
        isLoading: false
      }) }
    </Form>
  );
};

export default React.memo(AssetDetail);
